import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/carriers/genericAccount`;

interface SetDeleteAccountCarrierArgs {
  sellerId: string;
  accountName: string;
  carrierName: string;
}

async function setDeleteAccountCarrier({
  sellerId,
  accountName,
  carrierName,
}: SetDeleteAccountCarrierArgs): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response = await apiCall(url, {
      method: SUPPORTED_METHODS.DELETE,
      json: {
        accountName,
        carrier: carrierName,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default setDeleteAccountCarrier;
